module.exports = __webpack_public_path__ + "img/cropped-earth-purple.746034cf.png";